export class EMERG {
    Type: string = "EMERG";
    SerialNumber:string;
    Status: boolean;
    StartDate: Date;
    EndDate: Date;
    Duration: number;
}